<script setup lang="ts">
  import type { ICloseArgs } from '#shared/types/modal.types';
  import SupportChat from '~/utils/services/support-chat.service';

  const emit = defineEmits<{
    close: [ICloseArgs];
  }>();

  function openTNC() {
    emit('close', {});
    navigateTo('/tnc');
  }
</script>

<template>
  <div class="flex flex-col gap-2.5 w-full pt-2 pb-6 text-white font-barlow text-xs font-normal leading-[150%]">
    <div class="flex gap-[14px]">
      <span>If you have trouble placing your order, contact our support.</span>
      <SvgoChatBubble class="w-5 cursor-pointer" @click="SupportChat.toggle" />
    </div>
    <div>
      <NuxtLink class="text-blue cursor-pointer underline" @click.prevent="openTNC">Terms and Conditions</NuxtLink>
      Apply. Please read for more information.
    </div>
  </div>
</template>
